module.exports = __webpack_public_path__ + "static/media/screenshot-11.2ede705e.jpg";